import AxiosInstance from "../../AxiosInstance";

export async function uploadProfileDocumentToAWS(file, userid) {
  const url = `/common/profile/document/${userid}`;
  const formData = new FormData();
  formData.append("file", file);

  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  try {
    let response = await AxiosInstance()
      .post(url, formData, config)
      .catch((err) => {
        console.log(err);
        throw err;
      });
    return response.data.key ? response.data.key : null;
  } catch (e) {
    return null;
  }
}
export async function uploadPolicyDocumentToAWS(file, id) {
  const url = `/common/policy/document/${id}`;
  const formData = new FormData();
  formData.append("file", file);

  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  try {
    let response = await AxiosInstance().post(url, formData, config);
    return response.data.key;
  } catch (e) {
    return "";
  }
}
